export default __webpack_public_path__ + "static/media/stairs.85b8362c.png";